import api from "@modules/api/api";
import { useQuery } from "@tanstack/react-query";
import tradeInQueryKeys from "../types/tradeInQueryKeys";

export type TradeInTokenData = {
  tradeInToken: string;
};

const getTradeInToken = async (source: string): Promise<TradeInTokenData> => {
  return api.get<TradeInTokenData>(`api/trade-in/${source}/token`);
};

export default function useTradeInToken(source: string) {
  const { data, error } = useQuery({
    queryKey: tradeInQueryKeys.token(source),
    queryFn: () => getTradeInToken(source),
    staleTime: 0,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return {
    tradeInTokenData: data,
    isLoading: !error && !data,
  };
}

const getTradeInTokenForId = async (
  source: string,
  tradeInId: string
): Promise<TradeInTokenData> => {
  return api.get<TradeInTokenData>(`api/trade-in/${source}/token/${tradeInId}`);
};

export function useTradeInTokenForId(source: string, tradeInId: string) {
  const { data, error } = useQuery({
    queryKey: tradeInQueryKeys.tokenForId(source, tradeInId),
    queryFn: () => getTradeInTokenForId(source, tradeInId),
    staleTime: 0,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!source && !!tradeInId,
  });

  return {
    tradeInTokenData: data,
    isLoading: !error && !data,
  };
}
